(() => {
  'use strict';
  if (window.GzPatchPicker) return;
  const instances = new Map();
  function watchGallery(root) {
    const main = root.closest('.product-main');
    const gallery = main?.querySelector('.js-product-gallery');
    const rail = main?.querySelector('.gallery-thumbnails--left > .product_gallery_nav, .gallery-thumbnails--right > .product_gallery_nav');
    if (!gallery || !rail) return () => {};
    let frame = 0;
    function update() {
      frame = 0;
      if (!window.matchMedia('(min-width: 799px)').matches) return;
      const height = Math.ceil(gallery.getBoundingClientRect().height);
      if (height < 1) return;
      const value = height + 'px';
      if (main.style.getPropertyValue('--gz-patch-gallery-height') !== value) main.style.setProperty('--gz-patch-gallery-height', value);
      rail.toggleAttribute('data-gz-rail-overflow', rail.scrollHeight > rail.clientHeight + 1);
      const id = gallery.querySelector('.gallery-cell.is-selected')?.dataset.mediaId;
      const selected = Array.from(rail.querySelectorAll('.gallery-cell')).find(cell => cell.dataset.mediaId === id);
      if (!selected) return;
      window.jQuery?.(rail).stop(true);
      const bounds = rail.getBoundingClientRect();
      const item = selected.getBoundingClientRect();
      if (item.top < bounds.top) rail.scrollTop += item.top - bounds.top;
      else if (item.bottom > bounds.bottom) rail.scrollTop += item.bottom - bounds.bottom;
    }
    function schedule() { if (!frame) frame = requestAnimationFrame(update); }
    const resize = new ResizeObserver(schedule);
    resize.observe(gallery);
    const selection = new MutationObserver(schedule);
    selection.observe(gallery, {subtree: true, childList: true, attributes: true, attributeFilter: ['class']});
    selection.observe(rail, {subtree: true, childList: true, attributes: true, attributeFilter: ['class']});
    rail.addEventListener('load', schedule, true);
    window.addEventListener('resize', schedule);
    schedule();
    return () => { resize.disconnect(); selection.disconnect(); rail.removeEventListener('load', schedule, true); window.removeEventListener('resize', schedule); cancelAnimationFrame(frame); main.style.removeProperty('--gz-patch-gallery-height'); rail.removeAttribute('data-gz-rail-overflow'); };
  }
  function mount(root) {
    if (instances.has(root)) return;
    let product;
    try { product = JSON.parse(root.dataset.product); } catch (_) { return; }
    if (product.options.length !== 1 || root.dataset.product_form_style !== 'select') return;
    const master = root.querySelector('[data-variants][name="id"]');
    const group = root.querySelector('.gz-patch-picker');
    const mode = product.variants.length > 2 ? 'select' : 'rows';
    if (!master || (mode === 'rows' && !group)) return;
    root.dataset.gzPickerMode = mode;
    const destroyGallery = watchGallery(root);
    const radios = Array.from(group?.querySelectorAll('input[type="radio"]') || []);
    let ready = false;
    let queued = false;
    let destroyed = false;
    function select() { return root.querySelector('.single-option-selector'); }
    function choose(id) {
      const variant = product.variants.find(item => String(item.id) === String(id));
      const native = select();
      if (!variant || !native || typeof native.onchange !== 'function') return false;
      native.value = variant.options[0];
      native.dispatchEvent(new Event('change', {bubbles: true}));
      return String(master.value) === String(variant.id);
    }
    function sync() {
      queued = false;
      if (destroyed || !root.isConnected) return;
      if (!ready) {
        const native = select();
        if (!native || typeof native.onchange !== 'function') return;
        ready = true;
        if (!choose(root.dataset.gzInitialVariant)) { ready = false; return; }
        if (group) group.hidden = false;
        root.classList.add('gz-patch-picker-ready');
      }
      const native = select();
      const variant = product.variants.find(item => String(item.id) === master.value && item.options[0] === native?.value);
      radios.forEach(radio => { radio.checked = Boolean(variant && String(variant.id) === radio.value); });
    }
    function schedule() {
      if (queued || destroyed) return;
      queued = true;
      queueMicrotask(sync);
    }
    function change(event) {
      if (radios.includes(event.target)) choose(event.target.value);
      schedule();
    }
    function variantChange(event) {
      if (event.detail?.selector?.variantIdField === master) schedule();
    }
    const observer = new MutationObserver(schedule);
    observer.observe(root, {childList: true, subtree: true});
    root.addEventListener('change', change);
    master.addEventListener('change', schedule);
    document.addEventListener('variant:change', variantChange);
    instances.set(root, () => {
      destroyed = true;
      destroyGallery();
      observer.disconnect();
      root.removeEventListener('change', change);
      master.removeEventListener('change', schedule);
      document.removeEventListener('variant:change', variantChange);
      instances.delete(root);
    });
    schedule();
  }
  function scan() { document.querySelectorAll('[data-gz-patch-picker]').forEach(mount); }
  window.GzPatchPicker = {scan};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, {once: true});
  else scan();
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((destroy, root) => { if (event.target.contains(root)) destroy(); });
  });
})();
